// extracted by mini-css-extract-plugin
module.exports = {"popupRow":"List_popupRow_3PaFz","pagination":"List_pagination_32fCA","paginationText":"List_paginationText_8KmyL","paginationButton":"List_paginationButton_1oxNa"};